import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahBudgets } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { DashboardExpandedResponse } from '~support-at-home/models/dashboard';

export type DashboardExpandedReq = {
  quarter: number;
  year: number;
  limit: number;
  offset: number;
  client_name?: string;
  worker_name?: string;
};

export const dashboardBudgetsExpandedApi = createApi({
  reducerPath: 'dashboardBudgetsExpandedApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahBudgets }),
  tagTypes: ['dashboard-budgets-expanded'],
  endpoints: (builder) => ({
    getDashboardOverUtilised: builder.query<DashboardExpandedResponse, DashboardExpandedReq>({
      query: ({ quarter, ...rest }) => ({
        url: '/dashboard/over-utilised',
        method: 'GET',
        params: { quarter: `Q${quarter}`, ...rest },
      }),
      providesTags: [{ type: 'dashboard-budgets-expanded', id: 'OVER_UTILISED' }],
      transformResponse: (payload) => unwrap<DashboardExpandedResponse>(payload),
    }),
    getDashboardOverUtilisedCm: builder.query<DashboardExpandedResponse, DashboardExpandedReq>({
      query: ({ quarter, ...rest }) => ({
        url: '/dashboard/over-utilised-cm',
        method: 'GET',
        params: { quarter: `Q${quarter}`, ...rest },
      }),
      providesTags: [{ type: 'dashboard-budgets-expanded', id: 'OVER_UTILISED_CM' }],
      transformResponse: (payload) => unwrap<DashboardExpandedResponse>(payload),
    }),
    getDashboardUnderUtilisedCm: builder.query<DashboardExpandedResponse, DashboardExpandedReq>({
      query: ({ quarter, ...rest }) => ({
        url: '/dashboard/under-utilised-cm',
        method: 'GET',
        params: { quarter: `Q${quarter}`, ...rest },
      }),
      providesTags: [{ type: 'dashboard-budgets-expanded', id: 'UNDER_UTILISED_CM' }],
      transformResponse: (payload) => unwrap<DashboardExpandedResponse>(payload),
    }),
    getDashboardCmWorkers: builder.query<DashboardExpandedResponse, DashboardExpandedReq>({
      query: ({ quarter, ...rest }) => ({
        url: '/dashboard/cm-workers',
        method: 'GET',
        params: { quarter: `Q${quarter}`, ...rest },
      }),
      providesTags: [{ type: 'dashboard-budgets-expanded', id: 'CM_WORKERS' }],
      transformResponse: (payload) => unwrap<DashboardExpandedResponse>(payload),
    }),
  }),
});

export const {
  useGetDashboardOverUtilisedQuery,
  useGetDashboardOverUtilisedCmQuery,
  useGetDashboardUnderUtilisedCmQuery,
  useGetDashboardCmWorkersQuery,
} = dashboardBudgetsExpandedApi;
